import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const NUMBER_OF_ITEMS = 5;
const MyCompanies = _ref => {
  let {
    companies,
    claimGroups
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const columns = [{
    text: ''
  }, {
    text: t('projects')
  }];
  if (!companies || !claimGroups) {
    return null;
  }
  const getProjectsNumber = company => {
    return claimGroups.filter(claimGroup => claimGroup.company_id === company.id).reduce((acc, claimGroup) => {
      return acc + claimGroup.projects_count;
    }, 0);
  };
  const rows = companies.slice(0, NUMBER_OF_ITEMS).map(company => {
    return {
      companyData: [company.name, `${location.pathname}/companies/${company.id}/overview`],
      companyProjectsNumber: getProjectsNumber(company)
    };
  });
  const handleViewAllCompanies = () => {
    history.push(`${location.pathname}/companies`);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "px-4 py-3 h-100"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-weight-bold"
  }, t('my_companies')), companies.length === 0 ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_companies_assigned')) : /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    style: {
      '--bs-table-striped-bg': 'transparent',
      '--bs-table-bg': 'transparent',
      '--bs-table-accent-bg': 'transparent'
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: 'transparent'
    }
  }, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement("th", {
      className: index === 0 ? 'text-end' : 'text-center',
      key: index
    }, column.text);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map((row, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: row.companyData[1]
    }, row.companyData[0])), /*#__PURE__*/React.createElement("td", {
      style: {
        background: 'transparent'
      },
      className: "text-center"
    }, row.companyProjectsNumber));
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "mt-auto"
  }), /*#__PURE__*/React.createElement(Button, {
    className: "me-auto",
    onClick: handleViewAllCompanies,
    variant: "text"
  }, t('view_all_companies')));
};
export default MyCompanies;